import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { createToggleReducer } from 'modules/utils';
import {
  acceptAndPayWorksFailure,
  acceptAndPayWorksSuccess,
  answerWorksFailure,
  answerWorksSuccess,
} from 'modules/entity/subEntities/intervention/actions/works';
import {
  callMeBackFailure,
  callMeBackSuccess,
  downloadMediasFailure,
  getPdfOfferFailure,
  getPdfOfferSuccess,
  getZipMediasFailure,
  getZipMediasSuccess,
  resetContactForm,
  sendContactFormFailure,
  sendContactFormSuccess,
  sendOpinionFailure,
  sendOpinionSuccess,
} from 'modules/entity/subEntities/intervention/actions/general';

import * as actionTypes from '../actionTypes';

export const acceptIsLoading = createToggleReducer(actionTypes.ANSWER_WORKS, answerWorksSuccess, answerWorksFailure);

export const acceptAndPayIsLoading = createToggleReducer(
  actionTypes.ACCEPT_AND_PAY_WORKS,
  acceptAndPayWorksSuccess,
  acceptAndPayWorksFailure
);

export const callMeBackIsLoading = createToggleReducer(actionTypes.CALL_ME_BACK, callMeBackSuccess, callMeBackFailure);

export const contactFormIsLoading = createToggleReducer(
  actionTypes.SEND_CONTACT_FORM,
  sendContactFormSuccess,
  sendContactFormFailure
);

export const contactFormIsSent = createToggleReducer(
  sendContactFormSuccess,
  actionTypes.SEND_CONTACT_FORM,
  resetContactForm
);

export const controlReportHasFiltered = createReducer(false, (builder) => {
  builder.addCase(actionTypes.SET_CONTROL_REPORT_FILTER, (_, { payload: value }) => value);
});

export const downloadMediasIsLoading = createToggleReducer(
  actionTypes.DOWNLOAD_MEDIAS,
  getZipMediasSuccess,
  getZipMediasFailure,
  downloadMediasFailure
);

export const finalInvoiceIsPaying = createToggleReducer(actionTypes.PAY_FINAL_INVOICE, actionTypes.PAY_FINAL_INVOICE_FAILURE);

export const opinionIsLoading = createToggleReducer(actionTypes.SEND_OPINION, sendOpinionSuccess, sendOpinionFailure);

export const payDepositIsLoading = createToggleReducer(actionTypes.PAY_DEPOSIT, actionTypes.PAY_DEPOSIT_FAILURE);

export const payOnlineIsLoading = createToggleReducer(actionTypes.PAY_ONLINE, actionTypes.PAY_ONLINE_FAILURE);

export const pdfOfferIsLoading = createToggleReducer(actionTypes.FETCH_PDF_OFFER, getPdfOfferSuccess, getPdfOfferFailure);

/**
 * @typedef {{
 *  ui: {
 *   accept: { isLoading: boolean },
 *   acceptAndPay: { isLoading: boolean },
 *   controlReport: { hasFiltered: boolean },
 *   payOnline: { isLoading: boolean },
 *   payDeposit: { isLoading: boolean },
 *   callMeBack: { isLoading: boolean },
 *   opinion: { isLoading: boolean },
 *   pdfOffer: { isLoading: boolean },
 *   downloadMedias: { isLoading: boolean },
 *   contactForm: { isLoading: boolean, isSent: boolean },
 *   finalInvoice: { isPaying: boolean },
 *  },
 * }} InterventionReducerState
 */

export default combineReducers({
  ui: combineReducers({
    accept: combineReducers({ isLoading: acceptIsLoading }),
    acceptAndPay: combineReducers({ isLoading: acceptAndPayIsLoading }),
    controlReport: combineReducers({ hasFiltered: controlReportHasFiltered }),
    payOnline: combineReducers({ isLoading: payOnlineIsLoading }),
    payDeposit: combineReducers({ isLoading: payDepositIsLoading }),
    callMeBack: combineReducers({ isLoading: callMeBackIsLoading }),
    contactForm: combineReducers({ isLoading: contactFormIsLoading, isSent: contactFormIsSent }),
    opinion: combineReducers({ isLoading: opinionIsLoading }),
    pdfOffer: combineReducers({ isLoading: pdfOfferIsLoading }),
    downloadMedias: combineReducers({ isLoading: downloadMediasIsLoading }),
    finalInvoice: combineReducers({ isPaying: finalInvoiceIsPaying }),
  }),
});
